export default __webpack_public_path__ + "static/media/delete_normal.cfd3c681.svg";